export default "__VITE_ASSET__23c9d4eb__"